import { msiRequest } from "../../../index";
import { ResultType } from "../../../types";
import qs from 'qs'
//接口url枚举
enum StatisticalEnumApi{
  CHECK_REPORT_PAGE = '/check/report/query',
  CHECK_REPORT_DETAIL = '/check/table/detail/query'

}
//盘点报表 --- 查询
export function getCheckReportPage(data: any = {}) {
  return msiRequest.get<ResultType<any>>({
    url: `${StatisticalEnumApi.CHECK_REPORT_PAGE}?${qs.stringify(data)}`,
    data
  })
}

//盘点报表 --- 详情
export function getCheckReportDetail(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
      url: `${StatisticalEnumApi.CHECK_REPORT_DETAIL}?${qs.stringify(data)}`,
      data
    })
  }


